import CascaderBox from './cascaderbox.vue';
export default CascaderBox;



// WEBPACK FOOTER //
// ./src/components/cascaderbox/index.js